import { Doughnut } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip
} from "chart.js";

ChartJS.register(ArcElement, Tooltip);

export default function ConversionGauge({
    value = 0,   // ex: vendas
    max = 100,   // ex: total de leads
    subtitle = "0 pagos de 0"
}) {

    const percentage = max > 0
        ? Math.min((value / max) * 100, 100)
        : 0;

    const data = {
        datasets: [
            {
                data: [percentage, 100 - percentage],
                backgroundColor: [
                    getComputedStyle(document.documentElement).getPropertyValue('--purple').trim() || '#8b5cf6',
                    "rgba(255,255,255,0.08)"
                ],
                borderWidth: 0,
                cutout: "75%",
                circumference: 180,
                rotation: 270,
                // borderRadius: 20
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: { enabled: false },
            legend: { display: false }
        },
        animation: {
            duration: 800
        }
    };

    return (
        <div className="w-full flex flex-col items-center justify-center">

            <div className="relative w-40 h-24">
                <Doughnut data={data} options={options} />

                <div className="absolute inset-0 flex flex-col items-center justify-center mt-12">
                    <span className="text-2xl font-bold text-white">
                    {percentage.toFixed(2)}%
                    </span>
                </div>
            </div>

            <div className="text-sm text-slate-400 text-center mt-2">
                {subtitle}
            </div>
        </div>
    );
}
